import { ICroCodeResult } from "../../interfaces/cro-result.interface";
import { RegisterForm, RegisterFormRequest } from '../../interfaces/forms/register-form.interface';
import { SenderIdsRequest } from "../../interfaces/sender-ids-request.interface";

export const toCompanyDetailsForm = ({
  companyAddress1,
  companyAddress2,
  companyAddress3,
  companyAddress4,
  companyName,
  placeOfBusiness,
  eircode,
}: Partial<ICroCodeResult> = {}, includeBusinessAddress = false): Partial<RegisterForm> => {
  const addressCountry = placeOfBusiness ? `${placeOfBusiness.charAt(0).toLocaleUpperCase()}${placeOfBusiness.slice(1).toLowerCase()}` : '';

  return {
    registeredAddressLine1: companyAddress1 ?? '',
    registeredAddressLine2: companyAddress2 ?? '',
    registeredAddressLine3: companyAddress3 ?? '',
    registeredAddressLine4: companyAddress4 ?? '',
    registeredAddressEircode: eircode ?? '',
    registeredAddressCountry: addressCountry,
    organisationName: companyName ?? '',
    ...(includeBusinessAddress && {
      businessAddressLine1: companyAddress1 ?? '',
      businessAddressLine2: companyAddress2 ?? '',
      businessAddressLine3: companyAddress3 ?? '',
      businessAddressLine4: companyAddress4 ?? '',
      businessAddressEircode: eircode ?? '',
      businessAddressCountry: addressCountry,
    }),
  };
};

export const toFormData = ({ fileContent, fileContentType, fileName, ...data }: RegisterFormRequest, file: File | null) => {
  const formData = new FormData();

  Object.entries(data).forEach(([key, value]) => {
    if (key === 'senderIds') {
      (value as unknown as SenderIdsRequest).senderIdList.forEach((entry, index) => {
        formData.append(`senderIds[SenderIdList][${index}][senderIdText]`, String(entry.senderIdText));
        entry.thirdPartyIdList.forEach((thirdPartyEntry, thirdPartyIndex) => {
          formData.append(`senderIds[SenderIdList][${index}][thirdPartyIdList][${thirdPartyIndex}]`, String(thirdPartyEntry));
        })
      });

      (value as unknown as SenderIdsRequest).opaList.forEach((opa, index) => {
        formData.append(`senderIds[opaList][${index}][accountId]`, String(opa.accountId));
      });
    } else {
      formData.append(key, String(value));
    }
  });

  formData.append('fileContent', file ?? '');
  formData.append('fileName', fileName ?? '');
  formData.append('fileContentType', file?.type ?? '');

  return formData;
};
